import { render, staticRenderFns } from "./OrderLogTable.vue?vue&type=template&id=bcf90502&scoped=true"
import script from "./OrderLogTable.vue?vue&type=script&lang=js"
export * from "./OrderLogTable.vue?vue&type=script&lang=js"
import style0 from "./OrderLogTable.vue?vue&type=style&index=0&id=bcf90502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf90502",
  null
  
)

export default component.exports